import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    stat1Number = "stat1Number",
    stat1Label = "stat1Label",
    stat2Number = "stat2Number",
    stat2Label = "stat2Label",
    stat3Number = "stat3Number",
    stat3Label = "stat3Label",
    stat4Number = "stat4Number",
    stat4Label = "stat4Label",
}

interface Props extends WidgetProps {
    fields: {
        [fields.stat1Number]: string;
        [fields.stat1Label]: string;
        [fields.stat2Number]: string;
        [fields.stat2Label]: string;
        [fields.stat3Number]: string;
        [fields.stat3Label]: string;
        [fields.stat4Number]: string;
        [fields.stat4Label]: string;
    };
}

export interface StatsGridStyles {
    gridSection?: InjectableCss;
    statBox?: InjectableCss;
    statNumber?: InjectableCss;
    statLabel?: InjectableCss;
}

const statsGridStyles: StatsGridStyles = {
    gridSection: {
        css: css`
            font-family: Barlow-Regular;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
            color: #fff;
            ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 0px;
                        margin-bottom: 30px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
        `,
    },
    statBox: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 30px;
            border-right: 1px solid #fff;
            border-bottom: 1px solid #fff;
            text-align: center;

            &:nth-child(2),
            &:nth-child(4) {
                border-right: none;
            }
            &:nth-child(3),
            &:nth-child(4) {
                border-bottom: none;
            }
            ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 15px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
        `,
    },
    statNumber: {
        css: css`
            font-size: 3.9rem;
            margin-bottom: 0px;
            font-family: Barlow-Bold;
            line-height: 70px;
            ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        font-size: 2.5rem;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
        `,
    },
    statLabel: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            padding: 0px 20px;
            ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 10px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
        `,
    },
};

const styles = statsGridStyles;

export const AboutUsNationalSection: React.FC<Props> = ({ fields }) => {

    return (
        <StyledWrapper {...styles.gridSection}>
            <StyledWrapper {...styles.statBox}>
                <Typography {...styles.statNumber}>{fields.stat1Number}</Typography>
                <Typography {...styles.statLabel}>{fields.stat1Label}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.statBox}>
                <Typography {...styles.statNumber}>{fields.stat2Number}</Typography>
                <Typography {...styles.statLabel}>{fields.stat2Label}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.statBox}>
                <Typography {...styles.statNumber}>{fields.stat3Number}</Typography>
                <Typography {...styles.statLabel}>{fields.stat3Label}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.statBox}>
                <Typography {...styles.statNumber}>{fields.stat4Number}</Typography>
                <Typography {...styles.statLabel}>{fields.stat4Label}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: AboutUsNationalSection,
    definition: {
        group: "Basic",
        icon: "text",
        displayName: "About us National Reach Section",
        fieldDefinitions: [
            {
                name: fields.stat1Number,
                displayName: "Stat 1 Number",
                editorTemplate: "TextField",
                defaultValue: "240+",
                fieldType: "Contextual",
            },
            {
                name: fields.stat1Label,
                displayName: "Stat 1 Label",
                editorTemplate: "TextField",
                defaultValue: "North American Locations",
                fieldType: "Contextual",
            },
            {
                name: fields.stat2Number,
                displayName: "Stat 2 Number",
                editorTemplate: "TextField",
                defaultValue: "150+",
                fieldType: "Contextual",
            },
            {
                name: fields.stat2Label,
                displayName: "Stat 2 Label",
                editorTemplate: "TextField",
                defaultValue: "Service, Repair, and Fabrication Centers",
                fieldType: "Contextual",
            },
            {
                name: fields.stat3Number,
                displayName: "Stat 3 Number",
                editorTemplate: "TextField",
                defaultValue: "1K+",
                fieldType: "Contextual",
            },
            {
                name: fields.stat3Label,
                displayName: "Stat 3 Label",
                editorTemplate: "TextField",
                defaultValue: "Suppliers of Innovative Technology",
                fieldType: "Contextual",
            },
            {
                name: fields.stat4Number,
                displayName: "Stat 4 Number",
                editorTemplate: "TextField",
                defaultValue: "500K+",
                fieldType: "Contextual",
            },
            {
                name: fields.stat4Label,
                displayName: "Stat 4 Label",
                editorTemplate: "TextField",
                defaultValue: "Available Product Offerings",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;